
import { Component } from 'vue-property-decorator'
import { CitizenPassportVue } from '@/citizen-passport/base'
import ProgressBar from '@/commons/components/core/ProgressBar.vue'
import LoadingSpinner from '@/commons/components/core/LoadingSpinner.vue'
import SummaryContent from '@/commons/components/summary/SummaryContent.vue'

@Component({
    components: {
        ProgressBar,
        SummaryContent,
        LoadingSpinner
    }
})
export default class CitizenPassportSummary extends CitizenPassportVue {
    isLoading = false

    created (): void {
        document.title = this.$tc('metadata.summaryAndStateFee')
    }

    toggleLoadingSpinner () {
        this.isLoading = !this.isLoading
    }
}
